const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const GlobaldataQuery: any = {
    GetGlobalDataToken: `${Backofficebff}/v1/globaldata/get-tokens`,
    GetSupportedCountries: `${Backofficebff}/v1/globaldata/bo-supported-country-by-instanceid`,
    GetInstances: `${Backofficebff}/v1/globaldata/instance-list`,
    GetCountries: `${Backofficebff}/v1/globaldata/country-list`,
    GetLanguages: `${Backofficebff}/v1/globaldata/language-list`,
    GetSupportedLanguages: `${Backofficebff}/v1/globaldata/bo-supported-language-by-instanceid`,
    GetGlobaldataRedisData: `${Backofficebff}/globaldata-managecache/redis-data`,
    GetGlobaldataRedisKeyDetail: `${Backofficebff}/globaldata-managecache/get-redis-by-key`,
    GetGlobaldataDefaultDatabase: `${Backofficebff}/globaldata-managecache/get-default-database`,
    GetSupportedCurrencies: `${Backofficebff}/v1/globaldata/get-country-supported-currency-list`,
};
